<div class="flex row-collapse space-between items-center mb-28">
  <button pButton class="atlas-btn atlas-btn-secondary tall" type="button"
    title="{{ 'profiles.relationships.back-to-profile' | translate | uppercase }}"
    [routerLink]="['/profile', profileId]" [icon]="'pi pi-angle-left'"
    [label]="'profiles.transactions.back-to-profile' | translate | uppercase">
  </button>
</div>

<div class="flex row-collapse items-center-start gap-27px mb-28">
  <div class="mct-flex mct-justify-start mct-items-start">
    <span class="title-header">{{ 'profiles.transactions.title' | translate | titlecase }}</span>
  </div>

  <div *ngIf="totalAmountDue > 0">
    <strong>
      <span class="grey-font">
        {{ 'profiles.view.revenue.total-amount-due' | translate }}
      </span>
      {{ totalAmountDue | currency }}
    </strong>
  </div>

  @if (hasMemberPortal) {
  <div>
    <a (click)="openShareLinkDialog()">
      <i class="pi pi-share-alt"></i>
      {{ 'profiles.transactions.share-link-to-online-bill-pay' | translate }}
    </a>
  </div>
  }
</div>

@if (!profile) {
<wl-busy [show]="!profile"></wl-busy>
}
@if (profile) {
<div class="flex row-collapse items-center-start gap-13px">
  <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd" [profileId]="profile.OrgInd"
    [memberTypeIconColor]="profile.MemberTypeIconColor"
    [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }"></wl-profile-type-icon>
  <span>
    <strong>{{ profile.ReportName }}</strong> ({{ profile.ProfileId }})
  </span>
</div>
}

@if (invoiceSearchParams) {
<wl-transactions-grid [searchParams]="invoiceSearchParams" [profileId]="profileId"></wl-transactions-grid>
}

<wl-share-link-dialog>
  <atlas-header>{{ 'profiles.transactions.share-link-to-online-bill-pay' | translate }}</atlas-header>
  <div class="mt-20">{{ 'profiles.transactions.share-link-help-text' | translate }}</div>
</wl-share-link-dialog>
